// extracted by mini-css-extract-plugin
module.exports = {"editTag":"styles_editTag__34NcK","tagInput":"styles_tagInput__1SCKJ"};